import React from "react";
import Link from "next/link";
import axios from "axios";
import API from "../../axios-setup/web-api";

const Sidebar = () => {
  const [featuredCourses, setFeaturedCourses] = React.useState(null);

  React.useEffect(() => {
    const getAllFeaturedCourses = async () => {
      const res = await API.get("/products/featured");

      setFeaturedCourses(res.data.data.rows);
    };
    getAllFeaturedCourses();
    featuredCourses ? console.log(featuredCourses) : console.log("no data");
  }, []);

  return (
    <div className="widget-area">
      <div className="widget widget_insight">
        <ul>
          {/* <li></li> */}
          <li>
            <Link href="/contact">
              <a>Contact Us</a>
            </Link>
          </li>
          {/* <li></li> */}
          <li>
            <Link href="/privacy-policy">
              <a>Privacy Policy</a>
            </Link>
          </li>
          <li>
            <Link href="/terms-of-service">
              <a>Terms of Service</a>
            </Link>
          </li>
        </ul>
      </div>

      <div className="widget widget_recent_courses">
        <h3 className="widget-title">Featured Products</h3>

        {featuredCourses &&
          featuredCourses.map((course) => (
            <div className="item">
              <Link href="#">
                <a className="thumb">
                  <img src={course.img1} alt="image" />
                </a>
              </Link>
              <div className="info">
                <span>₹{course.offer_price}</span>
                <h4 className="title usmall">
                  <Link href="#">
                    <a>{course.name}</a>
                  </Link>
                </h4>
              </div>
              <div className="clear"></div>
            </div>
          ))}
      </div>

      {/* <div className="widget widget_tag_cloud">
        <h3 className="widget-title">Popular Tags</h3>

        <div className="tagcloud">
          <Link href="#">
            <a>
              Business <span className="tag-link-count">(3)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Design <span className="tag-link-count">(3)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Braike <span className="tag-link-count">(2)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Fashion <span className="tag-link-count">(2)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Travel <span className="tag-link-count">(1)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Smart <span className="tag-link-count">(1)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Marketing <span className="tag-link-count">(1)</span>
            </a>
          </Link>

          <Link href="#">
            <a>
              Tips <span className="tag-link-count">(2)</span>
            </a>
          </Link>
        </div>
      </div> */}
    </div>
  );
};

export default Sidebar;
